export const SCHOOL_ID_LENGTH=11;